import { Component, inject } from '@angular/core';
import { SeoService } from '../../shared/seo.service';
import { SEO_PAGES_CONFIG } from '../../shared/header/header.lists';
import { Pages } from '../../shared/types/common.enums';

@Component({
  selector: 'app-our-story',
  imports: [],
  templateUrl: './our-story.component.html',
  styleUrl: './our-story.component.scss'
})
export class OurStoryComponent {
  #seoService = inject(SeoService);

  constructor() {
    this.#seoService.setUpSEOTags(SEO_PAGES_CONFIG[Pages.ourStory]);
  }
}
